import {Link} from "react-router-dom";
import i18n from "../i18n";
import React from "react";


class ProductItemPortal extends React.Component
{
    constructor(props) {
        super(props);
    }

    render() {
        const product = this.props.product;
        return <div
            className="product"
        >
            <div
                className="image"
                style={{backgroundImage: "url('" + product.thumbnail + "')"}}
            ></div>
            <div className="info">
                <Link
                    to={`/products/${product.id}`}
                    className="name"
                >
                    <span className="fs-sm">&times;{product.quantity}</span>
                    &nbsp;
                    {i18n.get_name(product)}
                </Link>
                <span className="price">
                        <span>{product.quantity} {i18n.t("qty_metric")}</span>
                      </span>
            </div>
        </div>
    }
}

export default ProductItemPortal;